import { Component, Input, OnInit, Inject, ViewChild, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import { AppServiceService } from 'src/app/app-service.service';
import { Customer, Unit, UserDetailsMainModel } from 'src/app/user-details-model';
import { MyProfileComponent } from '../my-profile/my-profile.component';
import { environment } from 'src/environments/environment';


import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DatePipe, DOCUMENT } from '@angular/common';
import { AlertsServiceService } from '../../services/alerts-service.service';
import { DialogNotificationDyComponent } from '../dialog-notification-dy/dialog-notification-dy.component';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ProductConfigAdminService } from 'src/app/product-config-admin/product-config-admin.service';
import { RoleModuleAccess, UserModel } from 'src/app/product-config-admin/product-config';
import { Router } from '@angular/router';
import { RoleModuleMappingService } from 'src/app/authmanager/RoleModuleMapping';
import { SignalrService } from 'src/app/signalr.service';
import { CommonService } from '../../services/common.service';
import { Dialog } from 'primeng/dialog';






@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent implements OnInit {
  @Input() toShowProdConfig: boolean = true;
  @Input() toShowUnitConfig: boolean = true;
  @Input() toShowProfile: boolean = true;
  @Input() toShowHelp: boolean = true;
  @Input() toShowCustomerName: boolean = true;
  @Input() isAlertNotificationIcon: boolean = false;
  @ViewChild('op') op: OverlayPanel | undefined;
  @ViewChild('dialogContainer', { static: false }) dialogContainer: ElementRef;
  @ViewChild('notify') notify: DynamicDialogRef;

  isPanelVisible: boolean = false;
  trustedDashboardUrl: SafeUrl = null;
  userDetails: UserDetailsMainModel;
  public notifymsg = [];
  notificationShow: Boolean = false;
  hubSubscription;
  public notificationlistener: any[];
  notificationDetailMsg: any = null;
  notificationRecommendation: Boolean = false;
  notificationHeaderMsg: string = 'Re-Allocation Recommendation';
  ref: DynamicDialogRef;
  path: string = environment.File_Path + "assets/images/";

  selectedCustomer: Customer;
  selectedUnit: Unit;
  helpUrl: string;
  lstRolesArr: any[] = [];
  constructor(private domSanitizer: DomSanitizer, private appService: AppServiceService,
    public dialogService: DialogService,
    private commonService: CommonService,
    private alertService: AlertsServiceService,
    public signalRService: SignalrService,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private datepipe: DatePipe,
    private productConfigAdminService: ProductConfigAdminService,
    private roleModuleMappingService: RoleModuleMappingService,
    public renderer: Renderer2) {
    this.helpUrl = environment.HELP_URL;

  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;  
    const cardElement = document.getElementById('defaultDropdown');
    const clickOutSide = document.getElementById('myover');
    const clickDropDown = document.getElementById('btn-prof'); 
    if (clickOutSide && !(clickOutSide.contains(event.target as Node) || clickDropDown.contains(event.target as Node))) {
      this.op.hide();  
    }
    if (cardElement && !cardElement.contains(event.target as Node)) {
      this.notificationShow = false;
    }
  }





  ngOnInit(): void {
    this.appService.userDetails.subscribe(d => this.userDetails = d);
    this.appService.selectedCustomer.subscribe(d => this.selectedCustomer = d);
    this.appService.selectedUnit.subscribe(d => this.selectedUnit = d);
    this.getRolesAccessData();
    // this.signalRService.startConnection();
    this.notificationCall();
    if (this.selectedCustomer?.logo && this.selectedCustomer?.logo != null) {
      this.trustedDashboardUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this.selectedCustomer.logo);
    }


  }

  logout() {

    this.appService.logoutNew();
  }
  ShowProfileDetails(id: number) {
    this.ref = this.dialogService.open(MyProfileComponent, {
      data: {
        id: id,
      },
    });
    // ref.onClose.subscribe(() => {
    // });
  }

  acknowledge(alertNotificationId) {
    const notification = {
      alertNotificationId: alertNotificationId,
      acknowledged: true,
      acknowledgedBy: localStorage.getItem('appEmail'),
    }
    this.alertService.acknowledgeAlert(notification).subscribe((data) => { });
  }
  // signalR notification call
  notificationCall() {
    this.hubSubscription = this.signalRService.notificationlistener.subscribe((data: any) => {
      this.notificationlistener = data;
      if (data != null && data.notificationType == 'alert') {
        this.notifymsg.unshift({ name: data.message, date: data.date, alertType: data.alertType, notificationId: data.notificationId })

      }
      if (this.notificationlistener) {
        if (data.notificationType == 'alert') {
          this.notificationShow = true;
          setTimeout(() => { this.notificationShow = false; }, 9000);
        }

        if (data.notificationType == 'notification' && data != null) {
          this.notificationDetailMsg = data;
          this.notificationRecommendation = true;
          this.notificationHeaderMsg = data.alertType;
        }

        if (data.notificationType == 'notification idle' && data != null) {
          this.notificationDetailMsg = data;

          this.ref = this.dialogService.open(DialogNotificationDyComponent, {
            header: 'Idle Alert',
            width: 'auto',
            contentStyle: { 'max-height': '500px', overflow: 'auto' },
            baseZIndex: 10000,
            data: data,
            closable: false,
            styleClass: 'notifyRecommendation',
            dismissableMask: true

          });

          const frameZones = this.document.getElementsByTagName('p-dynamicdialog');

          let marginVal = 5 * frameZones.length;
          frameZones[frameZones.length - 1].getElementsByTagName('div')[0].style.margin = marginVal + 'px';
          frameZones[frameZones.length - 1].getElementsByTagName('div')[0].style.backgroundColor = 'transparent';

          if (frameZones.length > 5) {
            this.rePositionTheDialog();
          }
        }

        if (data.notificationType == 'notification cycletime' && data != null) {
          this.notificationDetailMsg = data;


          this.ref = this.dialogService.open(DialogNotificationDyComponent, {
            header: 'Dumper Cycle Time Alert',
            width: 'auto',
            contentStyle: { 'max-height': '500px', overflow: 'auto' },
            baseZIndex: 10000,
            data: data,
            closable: false,
            styleClass: 'notifyRecommendation',
          });

          const frameZones = this.document.getElementsByTagName('p-dynamicdialog');

          let marginVal = 5 * frameZones.length;
          frameZones[frameZones.length - 1].getElementsByTagName('div')[0].style.margin = marginVal + 'px';
          frameZones[frameZones.length - 1].getElementsByTagName('div')[0].style.backgroundColor = 'transparent';

          if (frameZones.length > 5) {
            this.rePositionTheDialog();
          }
        }
      }
    });
  }
  rePositionTheDialog() {
    const frameZones = this.document.getElementsByTagName('p-dynamicdialog');
    // if (frameZones.length > 0) {
    //   frameZones[0].remove();
    // }
    if (frameZones.length > 0) {
      let marginVal = 5;
      for (let index = 0; index < frameZones.length; index++) {
        const element = frameZones[index];
        element.getElementsByTagName('div')[0].style.margin = marginVal + 'px';
        element.getElementsByTagName('div')[0].style.backgroundColor = 'transparent';
        marginVal += 5;
      }
    }

  }
  getImagePath(data: any) {
    return this.path + "alert-icon-1.png";

  }
  // toHideOverly(event: MouseEvent) {
  //   this.op.hide();
  // }
  getRolesAccessData() {
    this.lstRolesArr = [];
    this.productConfigAdminService.getRoleModuleMapping(this.selectedCustomer.customerId).subscribe((data: RoleModuleAccess[]) => {
      if (data?.length > 0) {
        this.lstRolesArr = data;
      }
    });
  }
  onRedirect(key: any) {
    let lstRoleName = this.lstRolesArr.find(role => role.roleName == this.userDetails.roles[0].roleName);

    let requestedModuleName = this.roleModuleMappingService.GetLeftModules(key);;

    // this.op.hide();
    if (key == 10) {
      if (lstRoleName.associatedModules.some(s => s.moduleName == requestedModuleName && s.accessLevels.length > 0)) {
        // this.router.navigate(['../../../product-config/equipment-management']);
        this.router.navigateByUrl('/product-config/equipment-management');

      }
      else {
        this.router.navigate(['../../../access-denied']);
      }
    }
    else if (key == 11) {
      if (lstRoleName.associatedModules.some(s => s.moduleName == requestedModuleName && s.accessLevels.length > 0)) {

        this.router.navigateByUrl('/user-module/unit-config');

      }
      else {
        this.router.navigate(['../../../access-denied']);
      }
    }
  }

  toCheckUnitLenght() {
    if (this.userDetails.units.length > 1) {
      this.router.navigate(['/customer-admin/view-units']);
    }
    else {
      this.router.navigate([], { skipLocationChange: true });
    }
  }

  ViewRecommendation() {
    this.commonService.GetCurrentShiftDetails(this.selectedUnit.id).subscribe(
      (shiftDetails: any) => {
        if (shiftDetails != null) {
          this.notificationRecommendation = false;
          this.router.navigate(["user-module/operations-control/Resource-Allocation/DispatchPlan/" + this.datepipe.transform(shiftDetails.currentShift.shiftDate, 'yyyy-MM-dd') + "/" + shiftDetails.currentShift.shiftName]);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }


  togglePanel(event: MouseEvent, overlayPanel: OverlayPanel) { 
    overlayPanel.toggle(event);
  }


}


